export enum TrackingTypeEnum {
    TrackingNumber = 0,
    BOL = 1
}